module.exports = __webpack_public_path__ + "assets/734df89452416ce566117b78736f5697.mp3";